import * as Reducer from './slice';
import { IFeedbackState } from './types';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: IFeedbackState;
  // other features we don't care of
  [otherKeys: string]: any;
}

export const getFeedbackState = (state: IAppState) => state[Reducer.statePropName];

export const getFeedbackIsSent = (state: IAppState) => getFeedbackState(state).isSent;

export const getFeedbackShow = (state: IAppState) => getFeedbackState(state).show;
